import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IPoste } from 'src/app/shared/models/poste';
import { PosteService } from '../poste.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';

@Component({
  selector: 'app-poste-dialog',
  templateUrl: './poste-dialog.component.html',
  styleUrls: ['./poste-dialog.component.less']
})
export class PosteDialogComponent implements OnInit {

  form!: UntypedFormGroup;
  isEditMode: boolean;
  isSubmitting = false;
  backendError: string | null = null;

  constructor(
    private _fb: UntypedFormBuilder,
    private posteService: PosteService,
    private snackbarService: SnackbarService,
    public dialogRef: MatDialogRef<PosteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IPoste | null
  ) {
    this.isEditMode = data != null;
  }

  ngOnInit(): void {
    this.form = this._fb.group({
      libelle: [this.data?.libelle ?? '', [Validators.required, Validators.maxLength(120)]],
      active: [this.data?.active ?? true]
    });
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.backendError = null;
    this.isSubmitting = true;

    const { libelle, active } = this.form.value;

    const action$ = this.isEditMode
      ? this.posteService.update(this.data!.posteId, { libelle, active })
      : this.posteService.create({ libelle });

    action$.subscribe({
      next: (result) => {
        this.isSubmitting = false;
        this.snackbarService.openSnackBar(
          this.isEditMode ? 'Poste modifié avec succès' : 'Poste créé avec succès'
        );
        this.dialogRef.close(result);
      },
      error: (err) => {
        this.isSubmitting = false;
        this.backendError = this.extractErrorMessage(
          err,
          this.isEditMode ? 'Erreur lors de la modification du poste' : 'Erreur lors de la création du poste'
        );
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  private extractErrorMessage(err: any, fallback: string): string {
    const body = err?.error;
    if (body?.message && typeof body.message === 'string') return body.message;
    if (typeof body === 'string') return body;
    return fallback;
  }
}
